// removed by extract-text-webpack-plugin
module.exports = {"popover":"antd-pro-popover","noticeButton":"antd-pro-noticeButton","icon":"antd-pro-icon","tabs":"antd-pro-tabs"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/NoticeIcon/index.less
// module id = 374
// module chunks = 0 1